module.exports = __webpack_public_path__ + "img/canopy-arched.6e0f2ae6.svg";